import { useTranslation } from 'react-i18next'

export interface DropdownOptionsAttractiveness {
  yesNoOptions: Array<{ value: boolean; label: string }>
  businessTypeOptions: Array<{ value: string; label: string }>
  ageBucketOptions: Array<{ value: string; label: string }>
  trafficTypeOptions: Array<{ value: string; label: string }>
  transportMeansOptions: Array<{ value: string; label: string }>
  daypartOptions: Array<{ value: string; label: string }>
  weekpartOptions: Array<{ value: string; label: string }>
  marketTypeOptions: Array<{ value: string; label: string }>
}

export const useGetAttractivenessDropdownOptions = (): DropdownOptionsAttractiveness => {
  const { t } = useTranslation()

  const yesNoOptions = [
    {
      value: true,
      label: t('generic.yes'),
    },
    {
      value: false,
      label: t('generic.no'),
    },
  ]

  const businessTypeOptions = [
    {
      value: 'pharmacy',
      label: t('placeme.pois_tile.category.pharmacy'),
    },
    {
      value: 'cafe',
      label: t('placeme.pois_tile.category.cafe'),
    },
    {
      value: 'bank',
      label: t('placeme.pois_tile.category.bank'),
    },
    {
      value: 'bakery',
      label: t('placeme.pois_tile.category.bakery'),
    },
    {
      value: 'drugstore',
      label: t('placeme.pois_tile.category.drugstore'),
    },
    {
      value: 'grocery store',
      label: t('placeme.pois_tile.category.grocery-store'),
    },
    {
      value: 'restaurant',
      label: t('placeme.pois_tile.category.restaurant'),
    },
    {
      value: 'butcher',
      label: t('placeme.pois_tile.category.butcher'),
    },
    {
      value: 'gym',
      label: t('placeme.pois_tile.category.gym'),
    },
    {
      value: 'insurance',
      label: t('placeme.pois_tile.category.insurance'),
    },
    {
      value: 'optic_store',
      label: t('placeme.pois_tile.category.optic_store'),
    },
    {
      value: 'nursery',
      label: t('placeme.pois_tile.category.nursery'),
    },
    {
      value: 'kindergarten',
      label: t('placeme.pois_tile.category.kindergarten'),
    },
    {
      value: 'construction_store',
      label: t('placeme.pois_tile.category.construction-store'),
    },
    {
      value: 'blood_testing',
      label: t('placeme.pois_tile.category.blood-testing'),
    },
  ]

  const ageBucketOptions = [
    {
      value: 'age_0_18',
      label: t('placeme.attractiveness.age_buckets.0_18'),
    },
    {
      value: 'age_19_29',
      label: t('placeme.attractiveness.age_buckets.19_29'),
    },
    {
      value: 'age_30_44',
      label: t('placeme.attractiveness.age_buckets.30_44'),
    },
    {
      value: 'age_45_59',
      label: t('placeme.attractiveness.age_buckets.45_59'),
    },
    {
      value: 'age_60+',
      label: t('placeme.attractiveness.age_buckets.60_plus'),
    },
  ]

  const trafficTypeOptions = [
    {
      value: 'local',
      label: t('placeme.attractiveness.traffic.local'),
    },
    {
      value: 'transit',
      label: t('placeme.attractiveness.traffic.transit'),
    },
    {
      value: 'balanced',
      label: t('placeme.attractiveness.traffic.balanced'),
    },
  ]

  const transportMeansOptions = [
    {
      value: 'definitely_on_foot',
      label: t('placeme.attractiveness.transport_means.definitely_on_foot'),
    },
    {
      value: 'rather_on_foot',
      label: t('placeme.attractiveness.transport_means.rather_on_foot'),
    },
    {
      value: 'on_foot_and_by_car',
      label: t('placeme.attractiveness.transport_means.on_foot_and_by_car'),
    },
    {
      value: 'rather_by_car',
      label: t('placeme.attractiveness.transport_means.rather_by_car'),
    },
    {
      value: 'definitely_by_car',
      label: t('placeme.attractiveness.transport_means.definitely_by_car'),
    },
  ]

  const daypartOptions = [
    {
      value: 'morning',
      label: t('placeme.attractiveness.dayparts.morning'),
    },
    {
      value: 'lunch',
      label: t('placeme.attractiveness.dayparts.lunch'),
    },
    {
      value: 'afternoon',
      label: t('placeme.attractiveness.dayparts.afternoon'),
    },
    {
      value: 'evening',
      label: t('placeme.attractiveness.dayparts.evening'),
    },
    {
      value: 'night',
      label: t('placeme.attractiveness.dayparts.night'),
    },
  ]

  const weekpartOptions = [
    {
      value: 'weekdays',
      label: t('placeme.attractiveness.weekparts.weekdays'),
    },
    {
      value: 'weekend',
      label: t('placeme.attractiveness.weekparts.weekend'),
    },
  ]

  const marketTypeOptions = [{
    value: 'micro',
    label:t('placeme.attractiveness.market_type.micro'),
  }, {
    value: 'macro',
    label:t('placeme.attractiveness.market_type.macro'),
  }]

  return {
    yesNoOptions,
    businessTypeOptions,
    ageBucketOptions,
    trafficTypeOptions,
    transportMeansOptions,
    daypartOptions,
    weekpartOptions,
    marketTypeOptions,
  }
}
